module.exports = __webpack_public_path__ + "img/Cassandra.2ffa2ef.svg";